/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { signOut } from '../redux/actions/authActions';
import history from '../services/history';

const NoAccessPage = ({ onSignOut }) => {
  const handleLogout = () => {
    onSignOut();
    history.push('/login');
  };

  return (
    <div className="h-100 d-flex flex-column align-items-center justify-content-center p-4">
      <div className="coming-soon text-center">
        <h2 className="mb-3">You don&apos;t have access</h2>
        <p className="mb-2">
          Your account has no access to any screen.
          <span className="dot">.</span>
        </p>
        <p className="mb-4">Please contact the administrator to get access.</p>
        <Button type="primary" icon={<LogoutOutlined />} size="large" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  onSignOut: signOut,
};

export default connect(null, mapDispatchToProps)(NoAccessPage);
